// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navigation_navigation__3XZO-","list":"Navigation_list__Ha0gP","item":"Navigation_item__2JMCT","link":"Navigation_link__AFCJ6","selected":"Navigation_selected__F2Gr4"};